import { AUSTRALIA } from '../SpaceListingConstants';

export const setProfileData = (data) => {
  sessionStorage.setItem('profileListingData', JSON.stringify(data));
};

export const getProfileData = () => {
  const spaceData = JSON.parse(sessionStorage.getItem('profileListingData'));
  const removedTaxInfo = spaceData?.routeList?.filter((res) => {
    return !res.includes(`/dashboard/list-a-space/tax_information`);
  });
  return spaceData?.space_location?.[0]?.spaceCountry === AUSTRALIA
    ? { ...spaceData, routeList: removedTaxInfo }
    : JSON.parse(sessionStorage.getItem('profileListingData'));
};

/**
 * Returns the sub-path after "list-a-space/" so that the country prefix is
 * stripped and multi-segment routes (e.g. pricing_options/hourly/packages) are
 * treated as fully unique keys.  Falls back to the last segment for any path
 * that doesn't contain "list-a-space/".
 */
export const getListingStepPath = (path = '') => {
  const cleaned = String(path).split('?')[0].replace(/\/+$/, '');
  const marker = 'list-a-space/';
  const idx = cleaned.indexOf(marker);
  if (idx >= 0) return cleaned.slice(idx + marker.length).toLowerCase();
  // fallback: last segment only (e.g. for paths without the marker)
  const parts = cleaned.split('/').filter(Boolean);
  return (parts[parts.length - 1] || '').toLowerCase();
};

/** Last path segment for a listing route, e.g. uploading_images (kept for external usage) */
export const getListingStepSlug = (path = '') => {
  const cleaned = String(path).split('?')[0].replace(/\/+$/, '');
  const parts = cleaned.split('/').filter(Boolean);
  return parts[parts.length - 1] || '';
};

/**
 * Keep navigation inside the current country URL prefix.
 * routeList can be seeded with /all/... while the user is on /Sri-Lanka/...
 */
export const alignListingRouteCountry = (route, pathname = window.location.pathname) => {
  if (!route) return null;

  const currentParts = String(pathname).split('/').filter(Boolean);
  const routeParts = String(route).split('/').filter(Boolean);

  if (currentParts[0] && routeParts.length >= 4 && currentParts[1] === 'dashboard') {
    routeParts[0] = currentParts[0];
    return `/${routeParts.join('/')}`;
  }

  return route;
};

/**
 * Find current step in routeList by its full sub-path after "list-a-space/".
 * Using only the last slug caused collisions when multiple charging types
 * produce routes with the same final segment (e.g. daily/packages vs
 * hourly/packages both resolve to "packages"), making findIndex always return
 * the first match and locking navigation in a loop.
 */
export const getListingRouteIndex = (pathname, routeList = getProfileData()?.routeList || []) => {
  const stepPath = getListingStepPath(pathname);
  if (!stepPath || !Array.isArray(routeList)) return -1;

  return routeList.findIndex((route) => getListingStepPath(route) === stepPath);
};

export const getNextListingRoute = (pathname = window.location.pathname) => {
  const routeList = getProfileData()?.routeList || [];
  const currentIndex = getListingRouteIndex(pathname, routeList);
  if (currentIndex < 0 || currentIndex >= routeList.length - 1) return null;
  return alignListingRouteCountry(routeList[currentIndex + 1], pathname);
};

export const getPreviousListingRoute = (pathname = window.location.pathname) => {
  const routeList = getProfileData()?.routeList || [];
  const currentIndex = getListingRouteIndex(pathname, routeList);
  if (currentIndex <= 0) return null;
  return alignListingRouteCountry(routeList[currentIndex - 1], pathname);
};
